/* unplugin-vue-components disabled */import script from "./Admin.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin.vue?vue&type=script&setup=true&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=0df7afd4&lang=css"

const __exports__ = script;

export default __exports__